import React from 'react'

const Educationandhumanity = () => {
  return (
    <div>
       <div>
        <h3>Ways with words</h3>
        <p className='question'>A. Find the words from the text which mean the following.</p>
        <p>a. a messenger or representative, especially one on a diplomatic mission</p>
        <strong>envoy</strong>
        <p>b. the state or quality of being worthy of honor or respect</p>
        <strong>dignity</strong>
        <p>c. harm done to someone in response to harm</p>
        <strong>revenge</strong>
        <p>d. a person who holds extreme views in political or religious matters</p>
        <strong>extremist</strong>
        <p>e. sympathetic pity and concern for the sufferings or misfortunes of others</p>
        <strong>compassion</strong>
        <p>f. a person who is believed to speak for God</p>
        <strong>prophet</strong>
        <p>g. the study of the nature of knowledge, reality and existence</p>
        <strong>philosophy</strong>
        <p>h. the use of physical force so as to injure, abuse, damage or destroy</p>
        <strong>violence</strong>
        <p>i. an unreasonable dislike of a particular group of people or things</p>
        <strong>prejudice</strong>
       </div>
       <hr/>
       <div>
        <p className='question'>B. Match the words on the left with their opposite meanings on the right.</p>
        <p>honour ------ disgrace</p>
        <p>innocent ------ guilty</p>
        <p>brutality ------ kindness</p>
        <p>forgiveness ------ punishment</p>
        <p>illiteracy ------ literacy</p>
       </div>
       <hr/>
       <div>
         <p className='question'>a. Study the dictionary entry above and answer these questions.</p>
         <p>i. What is the headword in the first entry?</p>
         <p>= The headword in the first entry is Humanity.</p>
         <p>ii. How many meanings of the word humanity' are given?</p>
         <p>= Four meanings of the word 'humanity' are given.
</p>
          <p>iii. What do the abbreviations U, OPP, pl, and sth stand for?</p>
          <p>= U, OPP, pl and sth stand for uncountable, opposite, plural and something respectively.</p>
          <p>iv. What is the British English spelling of 'humanize'?</p>
          <p>= The British English spelling of 'humanize' is humanise.</p>
          <p>v. How is the word 'humanize' pronounced?</p>
          <p>= The word 'humanize' is pronounced as /'hju:mənaIz /.</p>
          <p>vi. If we say Every person should have the sense of humanity, which meaning of 'humanity' is applied?</p>
          <p>= If we say Every person should have the sense of humanity, the quality of being kind to people and animals by making sure that they do not suffer more than is necessary of 'humanity' is applied.</p>

       </div>
       <hr/>
       <div>
        <p className='question'>b. Arrange the following words in alphabetical order.</p>
        <p>i. advance analysis amuse assure allergy attain aid anxiety acute agreement</p>
        <p>acute, advance, agreement, aid, allergy, amuse, analysis, anxiety, assure, attain</p>
        <p>ii. smoke small smart speaking smelling smoothly smuggler smashed smearing smallpox</p>
        <p>small, smallpox, smart, smashed,speaking, smearing, smelling, smoke, smoothly, smuggler</p>
        <p>iii. terminal terminate terminology termite terms terrace terrible terribly</p>
        <p>terminal, terminate, terminology, terms, terrace, terrible, territory, terror</p>
       </div>
       <hr/>
       <div>
        <h3>Comprehension</h3>
        <p className='question'>Answer the following questions.</p>
        <p className='question'>a. Why did the speaker receive thousands of good-wishes cards and gifts from all over the world?</p>
        <p>= The speaker was shot by the Taliban on the left side of her forehead and was hospitalized for treatment and recovery. People from all over the world sent her thousands of good-wishes cards and gifts to show their support, love, and prayers for her recovery and bravery.</p>
        <p className='question'>b. According to the speaker, what are hundreds of human rights activists and social workers struggling for?</p>
        <p>= According to the speaker, hundreds of human rights activists and social workers are struggling to achieve their goals of education, peace, and equality.</p>
        <p className='question'>c. What has she learnt from Gandhi?</p>
        <p>= She has learnt the value of nonviolence and the power of peaceful protest from Gandhi.</p>
        <p className='question'>d. In what sense is peace necessary for education?</p>
        <p>= Peace is essential for providing quality education. Children can receive a fruitful education only when there is a peaceful environment. Without peace, children may be afraid to go to school, and even if they attend, they cannot concentrate on their studies. Therefore, peace plays a vital role in ensuring effective learning.</p>
        <p className='question'>e. According to the speaker, what are the main problems faced by both men and women?</p>
        <p>= According to the speaker, both men and women face major problems such as poverty, ignorance, injustice, racism, and the deprivation of basic rights.</p>
        <p className='question'>f. What is Malala calling upon all governments?</p>
        <p>= Malala is calling upon all governments to ensure free and compulsory education for all children around the world. She also urges them to fight against terrorism and violence, and to protect children from brutality and harm.</p>
        <p className='question'>g. What is the main message of this speech?</p>
        <p>= The main message of this speech is that education is a powerful weapon to eradicate problems like illiteracy, terrorism, violence, and the violation of fundamental human rights. Therefore, providing education to every child in the world should be the top priority of all governments.</p>
       </div>
       <div>
        <h3>Critical thinking</h3>
        <p className='question'>a. 'All children have the right to quality education. How can we ensure this right to every child? Discuss the role of the government and the parents to make sure that every child can attend school.'</p>
        <p>= Quality education is a fundamental need in the 21st century. To ensure this right for every child, the combined efforts of the government, parents, and schools are essential. These stakeholders must work together to create an environment where every child can access and benefit from meaningful learning.</p>
        <p>Role of the Government:</p>
        <p >1. The government can subsidize education by providing free or affordable schooling, especially for children from low-income families.
</p><p>
2. It should promote equality in education by ensuring that all public schools offer high-quality instruction and learning resources.
</p><p>
3. Teachers must be well-paid and professionally trained to stay motivated and deliver effective education.
</p><p>
4. The government should regularly update the curriculum to remove outdated content and align it with current needs and global standards.
</p><p>
5. Infrastructure development, such as safe classrooms, access to technology, and clean drinking water, should be prioritized.</p>
<p>Role of Parents:</p>
<p>1. Parents serve as role models, and their attitudes toward learning can inspire children to value education.
</p><p>
2. They should regularly communicate with their children about school experiences and provide emotional support.
</p><p>
3. Parents need to help children develop organized routines and time management skills, making sure there is dedicated time for study.
</p><p>
4. Creating a peaceful, encouraging, and resourceful learning environment at home is crucial for a child's academic growth.
</p><p>
5. They should also stay in touch with teachers and participate actively in their child's education.</p>
       </div>
       <hr/>
       <div>
        <p className='question'>b.'Do you think that there is still discrimination between sons and daughters in terms of providing education in our country? What strategies do you suggest to overcome such discrimination against girls?'</p>
        <p>= Yes, discrimination between sons and daughters still exists in Nepal, especially when it comes to providing quality education. Although the government has made progress by offering free education in public schools, these schools often lack proper funding, infrastructure, and teaching quality compared to private institutions. In many families, daughters are sent to government schools while sons are enrolled in better private schools. This reflects deep-rooted gender inequality in our society.</p>
        <p>This discrimination is largely based on traditional beliefs. Many parents believe that daughters will eventually marry and leave the family, so they are less likely to invest in their education. Sons, on the other hand, are expected to support the family in the future, and are therefore given more opportunities. There is also a common belief that males are stronger—physically, mentally, and politically—so parents prioritize sons when it comes to education.</p>
        <p>Strategies to Overcome Discrimination Against Girls in Education:</p>
        <p>1. Gender bias should be eliminated through awareness programs that promote equality and the value of girls' education.</p>
        <p>2. Girls and women should be given opportunities to hold positions of power and achieve economic independence.</p>
        <p>3. Violence, harassment, and sexual assault against girls and women must be strictly addressed and prevented to create a safe learning environment.</p>
        <p>4. The deep-rooted societal preference for sons should be changed through education and community engagement.</p>
        <p>5. Families should invest in their daughters' education instead of spending money on dowries.</p>
        <p>Ensuring equal educational opportunities for both sons and daughters is essential for achieving true progress and prosperity in the country.</p>
       </div>
       <hr/>
       <div>
         <p className='question'>c. 'A Chinese philosopher Confucius said, “If your plan is for one year, plant rice; if your plan is for ten years, plant trees; if your plan is for one hundred years, educate children.” What is the meaning of this saying? Elaborate this with examples.'</p>
         <p>= The meaning of this saying is that the time frame of your goals determines the kind of efforts you should make. If your plan is short-term, you focus on quick results, but if your plan is long-term, you invest in actions that take longer to bear fruit. The Chinese philosopher Confucius highlights that education is the most important investment for long-lasting and deep changes in society. Unlike planting rice or trees, which yield results in a year or a decade, educating children brings benefits that may take a century to fully manifest.</p>
         <p>This statement emphasizes the importance of education in shaping the future. People without education are like pens without ink, they lack the power to make an impact. Education builds our character, knowledge, and reputation in society. Without education, the dream of building a developed country remains just a castle in the air.</p>
         <p>If children receive quality education today, they will become responsible and skilled citizens who contribute to the nation's development and create a civilized society in the future. Therefore, investing in children's education is the best way to secure long-term progress and prosperity for the whole country.</p>
       </div>
       <hr/>
       <div>
        <h3>Grammar</h3>
        <p className='question'>Classify the underlined words into different word classes.</p>
        <p>a. The man who is wearing glasses is my uncle's friend.</p>
        <p>who: pronoun</p>
        <p>wearing: verb</p>
        <p>my: determiner</p>
        <br/>
        <p>b. I bought a round table in the supermarket.</p>
        <p>round: adjective</p>
        <p>the: determiner</p>
        <br/>
        <p>c. Alas, she is dead.</p>
        <p>Alas: interjection</p>
        <p>d. Hari works very hard all the time but his wife is very lazy.</p>
        <p>hard: adverb</p>
        <p>wife: noun</p>
        <p>very: adverb</p>
        <br/>
        <p>e. I have never been to Japan.</p>
        <p>never: adverb</p>
        <br/>
        <p>f. Ann drove a car safely.</p>
        <p>Ann: Noun</p>

        <p>Safely: Adverb</p>
        <br/>
        <p>g. Nobody has claimed it.</p>
        <p>nobody: pronoun</p>
        <p>it: pronoun</p>
        <br/>
        <p>h. She cut her hand with a knife.</p>
        <p>her: determiner</p>
        <p>with: preposition</p>
        <br/>
        <p>i. They have postponed the program because of rain.</p>
        <p>have: verb</p>
        <p>because of: preposition</p>
        <p>rain: noun</p>
        <br/>
        <p>j. Everybody comes to the party.</p>
        <p>everybody: pronoun</p>
        <br/>
        <p>k. All such people ought to be avoided.</p>
        <p>all: determiner</p>
        <p>such: determiner</p>
        <br/>
        <p>l. All of the food has gone.</p>
        <p>all: pronoun</p>
        <p>m. What was that noise?</p>
        <p>what: pronoun</p>
        <br/>
        <p>n. One must not boast of one's own success.</p>
        <p>one: pronoun</p>
        <br/>
        <p>o. Nobody was there to rescue the child.</p>
        <p>nobody: pronoun</p>
        <br/>
        <p>p. Neither of the accusations is true.</p>
        <p>neither: pronoun</p>
        <br/>
        <p>q. Neither answer is correct.</p>
        <p>neither: determiner</p>
        <br/>
        <p>r. Here is the book that you lent me.</p>
        <p>here: adverb</p>
        <p>that: pronoun</p>
        <br/>
        <p>s. Without health there is no happiness.</p>
        <p>without: proposition</p>
        <p>health: noun</p>
        <p>happiness: noun</p>
       </div>
    </div>
  )
}

export default Educationandhumanity
